"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _axios = _interopRequireDefault(require("axios"));

var _lodash = _interopRequireDefault(require("lodash"));

var _antd = require("antd");

var _TranslateAware = _interopRequireDefault(require("../TranslateAware/TranslateAware"));

var _TableActions = require("../../actions/TableActions");

var _Loader = _interopRequireDefault(require("../Loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Option = _antd.Select.Option; // TODO: Deprecated component. Use FilterForm/RemoteComboBox

var RemoteComboBox =
/*#__PURE__*/
function (_Component) {
  _inherits(RemoteComboBox, _Component);

  function RemoteComboBox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RemoteComboBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RemoteComboBox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      options: [],
      selectedValue: [],
      currency: ''
    });

    _defineProperty(_assertThisInitialized(_this), "getOptions", function (_ref) {
      var _this2 = this;

      var filterArgs = _ref.filterArgs;
      var _this$props = this.props,
          url = _this$props.url,
          translate = _this$props.translate,
          name = _this$props.name,
          mode = _this$props.mode;
      var startReq = (0, _moment["default"])();

      _axios["default"].post(url, _objectSpread({}, filterArgs, {
        paramsSerializer: function paramsSerializer(params) {
          return (0, _TableActions.parseParams)(params);
        }
      })).then(function (response) {
        var startTime = (0, _moment["default"])();
        var opts = [];

        if (response.data && response.data.length) {
          response.data.forEach(function (item) {
            var name;

            if (item.name) {
              name = translate(item.name);
            } else if (item.company) {
              name = translate(item.company);
            } else {
              name = translate(item.description);
            }

            var filterCurrency = '';

            if (typeof item === 'string') {
              filterCurrency = item;
            }

            opts.push({
              hjid: item.hjid,
              id: item.id || filterCurrency,
              name: name,
              currency: item.billing ? item.billing.currency : '',
              filterCurrency: filterCurrency
            });
          });
        }

        var newState = {
          options: opts,
          originOptions: opts
        };

        if (filterArgs[name] && mode !== "multiple" && filterArgs[name] !== _this2.state.selectedValue) {
          newState.selectedValue = filterArgs[name];
        }

        _this2.setState(newState);

        var endTime = (0, _moment["default"])();
        var duration1 = endTime.valueOf() - startReq.valueOf();
        var duration2 = endTime.valueOf() - startTime.valueOf();
        console.debug(name + " request:" + startReq.format("hh:mm:ss") + "; load:" + startTime.format("hh:mm:ss") + "; end: " + endTime.format("hh:mm:ss") + "; request: " + duration1 + "ms; load: " + duration2 + " ms");
      })["catch"](function (error) {
        console.error(error);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (option) {
      var options = _this.state.options;
      var tableType = _this.props.tableType;
      var params = {};
      /*
      * To get current chosen currency
      * */

      var currency = '';

      if (option && tableType === 'dashboard' && typeof option !== 'string') {
        var optionWithID = _lodash["default"].find(options, {
          id: +option[0]
        });

        currency = optionWithID ? optionWithID.currency : '';
      } // TODO: Temporary commented. Why it here? Fix it, broke http://localhost:3000/#/returns
      // params['currency'] = currency === '' ? 'EUR' : currency;


      params[_this.props.name] = option; // TODO: Simplify it. Put only combobox value.

      _this.props.onChange(params);

      _this.setState(_objectSpread({}, {
        selectedValue: option
      }, {
        currency: currency,
        options: _this.state.originOptions
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "fetchData", function (value) {
      var originOptions = _this.state.originOptions;

      _this.setState({
        fetching: true
      });

      var fetchingOptions = _lodash["default"].filter(originOptions, function (option) {
        return option.name.toUpperCase().indexOf(value.toUpperCase()) !== -1;
      });

      _this.setState({
        options: fetchingOptions,
        fetching: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectAll", function (selectedAll) {
      var selectedValue = !selectedAll ? _this.state.originOptions.map(function (v) {
        return v.id.toString();
      }) : [];

      _this.setState({
        selectedValue: selectedValue
      }, function () {
        _this.onChange(selectedValue);
      });
    });

    return _this;
  }

  _createClass(RemoteComboBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getOptions({
        filterArgs: this.props.filterArgs
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.reset && nextProps.reset) {
        this.setState({
          selectedValue: [],
          currency: ''
        });
      }

      if (!_lodash["default"].isEqual(this.props.filterArgs, nextProps.filterArgs) || !_lodash["default"].isEqual(this.props.emulationPartnerId, nextProps.emulationPartnerId)) {
        this.getOptions({
          filterArgs: nextProps.filterArgs
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          currency = _this$state.currency,
          selectedValue = _this$state.selectedValue,
          options = _this$state.options,
          fetching = _this$state.fetching;
      var _this$props2 = this.props,
          translate = _this$props2.translate,
          defaultValue = _this$props2.defaultValue,
          mode = _this$props2.mode;
      var existingSelectedValues = [];

      _lodash["default"].each(selectedValue, function (value) {
        if (_lodash["default"].find(options, function (option) {
          return option.id.toString() === value.toString();
        })) existingSelectedValues.push(value);
      });

      var value = defaultValue;

      if (mode === "multiple") {
        var isSelectedValueExist = existingSelectedValues.length > 0 ? existingSelectedValues.length : false;
        value = isSelectedValueExist ? existingSelectedValues : value;
      } else {
        var checkResult;

        if (selectedValue instanceof Array) {
          checkResult = !_lodash["default"].isEmpty(selectedValue);
        } else {
          checkResult = selectedValue;
        }

        value = checkResult ? selectedValue : value;
      }

      var selectedAll = value && value.length > 0 ? value.length === options.length : false;
      return _react["default"].createElement("div", {
        className: "remote-combo-box"
      }, _react["default"].createElement(_antd.Select, {
        showSearch: this.props.showSearch,
        allowClear: this.props.allowClear,
        showArrow: this.props.showArrow,
        filterOption: false,
        dropdownMatchSelectWidth: false,
        notFoundContent: fetching ? _react["default"].createElement(_Loader["default"], {
          size: "small"
        }) : null,
        placeholder: translate(this.props.title),
        className: "combo",
        value: value,
        onChange: this.onChange,
        onSearch: this.fetchData,
        mode: mode
      }, _lodash["default"].map(options, function (option) {
        var isDisabled = currency ? option.currency !== currency : false;
        return _react["default"].createElement(Option, {
          key: option.id,
          value: option.id.toString(),
          disabled: isDisabled
        }, option.name || option.filterCurrency);
      })), this.props.allowSelectedAll && _react["default"].createElement(_antd.Checkbox, {
        checked: selectedAll,
        onChange: function onChange() {
          _this3.selectAll(selectedAll);
        },
        disabled: !options.length
      }, this.props.translate('filterForm/selectAll')));
    }
  }]);

  return RemoteComboBox;
}(_react.Component);

RemoteComboBox.propTypes = {
  showSearch: _propTypes["default"].bool,
  allowClear: _propTypes["default"].bool,
  showArrow: _propTypes["default"].bool,
  filterArgs: _propTypes["default"].object
};
RemoteComboBox.defaultProps = {
  showSearch: false,
  allowClear: true,
  showArrow: false,
  filterArgs: {}
};

var _default = (0, _TranslateAware["default"])(RemoteComboBox);

exports["default"] = _default;